import httpRequest from "./../infrastructure/httphelper";
import sharedGlobals from "../sharedglobals";
import * as appUtilityfunctions from "../infrastructure/apputilityfunctions";
import * as appConstants from "../overrides/appconstants";
import * as sharedConstants from "../constants/sharedContants";
class SecurityService {
  constructor() {}
  
  
  setAuthCookie(sessionToken) {
    localStorage.setItem("sessionToken", sessionToken);
    document.cookie = "sessionToken=" + sessionToken ;
  }
  setSession(userSession) {
    sharedGlobals.sessionToken = userSession.sessionToken;
    this.setAuthCookie(userSession.sessionToken);
  }
  getAuthToken(){
    var authKey=appUtilityfunctions.readCookie('sessionToken');
    if(authKey==null||authKey==''){            
        authKey= localStorage.getItem('sessionToken');
    }
    if(authKey==null||authKey=='')
        return null;
    return decodeURIComponent(authKey);
  }
  getUserSessionByToken() {
    let url =
      sharedGlobals.appUrls.securityApiUrl + "api/Security/GetUserSession";
    return httpRequest({
      url: url,
      method: "POST",      
      headers:{
          "Content-Type1": "application/json",
          "Authorization": 'Bearer  '+this.getAuthToken()
      }
    });
  }
  hasMenus(menus,menusToCheck,requireAllMenus){
    let validMenus=[];    
    menusToCheck.forEach(menuToCheck=>{
            if(menus.find(p=>p.menuId==menuToCheck)){
                validMenus.push(menuToCheck);
            }            
    });
    if(requireAllMenus){
        return validMenus.length==menus.length;
    }
    return validMenus.length>0;
  }
  getSystemUrl(menus,pageId){
    let page=menus.find(p=>p.menuId==pageId);
    if(page.menuType==1){
        return this.getSystemUrlFromSystemMenuId(page.menuId)
    }
    let module=menus.find(p=>p.menuId==page.parentMenuId);
    if(module.menuType==1){
        return this.getSystemUrlFromSystemMenuId(module.menuId)
    }
    let system=menus.find(p=>p.menuId==module.parentMenuId);
    if(system.menuType==1){
      return this.getSystemUrlFromSystemMenuId(system.menuId)
    }  
    return this.getSystemUrlFromSystemMenuId(page.menuId);
  }
  getSystemUrlFromSystemMenuId(menuId){
    if(menuId==sharedConstants.SYSTEM_MENU_IDS.MICore){
      return sharedGlobals.appUrls.miCoreUrl;
    }
    return sharedGlobals.appUrls.ssoUrl+'dashboard';
  }
  
  
}
let instance = new SecurityService();
export default instance;
